import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
    name: 'profileUrl',
})
export class ProfileUrl implements PipeTransform {
    transform(value: string): string {
        let APP_URL = environment.baseUrl;
        if (value) {
            return value;
        }
        APP_URL += `/assets/images/dummy-user.jpg`;
        return APP_URL;
    }
}
